<template>
  <div class="Technology">
    <div class="Technology_center">
      <ModuleTitle :ModuleTitle="Module_title"></ModuleTitle>
      <div class="Technology_box">
        <div class="Technology_box_content" @click="toArticles()">
          <div class="Technology_img_box">
            <img src="../../../assets/image/Index/Technology_img.png" alt="" />
          </div>
          <div class="Technology_text">
            <p class="Technology_text_title">全国人大代表李书福</p>
            <div class="Technology_text_content">
              根据经济合作与发展组织 (OECD) 2 ⽉发布的
              《全球塑料展望：经济驱动因素、环境影响和
              政策选择》，⼈们对塑料污染的认识不断提⾼
              影响了公众舆论并导致了更强有⼒的…
            </div>
            <div class="open active_i">
              <i class="iconfont icon-jiantou1"></i>
            </div>
          </div>
        </div>
        <div class="Technology_box_content">
          <div class="Technology_img_box">
            <img src="../../../assets/image/Index/Technology_img1.jpg" alt="" />
          </div>
          <div class="Technology_text">
            <p class="Technology_text_title">全国人大代表李书福</p>
            <div class="Technology_text_content">
              李书福指出，甲醇作为低碳、含氧燃料，具有燃烧高效、排放清洁、可再生绿色属性等特点
            </div>
            <div class="open">
              <i class="iconfont icon-jiantou1"></i>
            </div>
          </div>
        </div>
        <div class="Technology_box_content">
          <div class="Technology_img_box">
            <img src="../../../assets/image/Index/Technology_img2.jpg" alt="" />
          </div>
          <div class="Technology_text">
            <p class="Technology_text_title">善用人工智能 拥抱平台社会</p>
            <div class="Technology_text_content">
              随着互联网平台逐渐成为人们生活的基础设施，各类信息安全隐患、数据权利问题也获得了社会各界重视。1月25日，“善用人工智能
              拥抱平台社会”——面向可持续发展的…
            </div>
            <div class="open">
              <i class="iconfont icon-jiantou1"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // Module_title: "Technology",
        Module_title: {name:"Technology",more:true}
    };
  },
  methods:{
     toArticles(){
      this.$router.push('/articles')
    }
  },
  components: {
    ModuleTitle: () =>
      import("../../PublicComponents/ModuleTitle/ModuleTitle.vue"),
  },
};
</script>

<style lang="scss" scoped>
.Technology {
  background: url("../../../assets/image/Index/Technology_bg.png") no-repeat;
  //   background-size: cover;
  background-size: 100% 100%;
  // background: 'url(' + require('../../../assets/image/Index/Society2.jpg') + ')';
  width: 100%;
  height: 654px;

  .Technology_center {
    overflow: hidden;
    width: 1200px;
    height: 100%;
    margin: 20px auto 0;

    .Technology_title {
      display: inline-block;
      margin: 40px 0 30px;
      color: #fff;
      padding: 10px 30px;
      background: #439f38;
    }
  }

  .Technology_box {
    display: flex;
    flex-direction: row;
    // height: 600px;
    .Technology_box_content:last-child {
      margin-right: 0px;
    }
    .Technology_box_content:first-child {
      margin-left: 0px;
    }
    .Technology_box_content {
      cursor: pointer;
      margin: 0 10px;
      // background: #ccc;
      width: 386px;
      height: 453px;

      .Technology_img_box {
        position: relative;
        width: 386px;
        height: 240px;

        img {
          width: 100%;
          height: 100%;
          border-radius: 4px;
          overflow: hidden;
        }
      }
      .Technology_text {
        width: 100%;
        height: 213px;
        background: #fff;
        color: #333333;
        border-radius: 0px 0px 0px 30px;
        position: relative;
        .Technology_text_title {
          padding: 20px 20px 15px 20px;
          //   height: 33px;
          font-size: 24px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 33px;
        }
        .Technology_text_content {
          word-wrap: break-word;
          word-break: normal;
          letter-spacing: 0px;
          padding: 0 20px;
          line-height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
        }
        .active_i{
          background: #0070ff !important;;
          i{
            color: #fff !important;
          }
        }
        .open {
          cursor: pointer;
          position: absolute;
          bottom: 25px;
          right: 36px;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          // background: #0070ff;
          border: 1px solid #0070ff;
          text-align: right;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          i {
            font-size: 14px;
            margin-left: 2px;
            font-weight: 600;
            color: #0070ff;
          }
        }
      }
    }
  }
}
</style>
